import { render, staticRenderFns } from "./base-quantity-card.vue?vue&type=template&id=6796b3da&scoped=true&"
import script from "./base-quantity-card.vue?vue&type=script&lang=js&"
export * from "./base-quantity-card.vue?vue&type=script&lang=js&"
import style0 from "./base-quantity-card.vue?vue&type=style&index=0&id=6796b3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6796b3da",
  null
  
)

export default component.exports